import { DatePipe } from '@angular/common';
import { Component, OnInit, Input, ViewChild, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { LITERALS } from 'src/app/core/constants/literals.constant';
import { REGEX_PATTERNS } from 'src/app/core/constants/regex-patterns.constant';
import { AuthService } from 'src/app/core/services/auth.service';
import { ProfileService } from 'src/app/core/services/profile.service';
import { environment } from 'src/environments/environment';
import { ErrorMessageComponent } from '../../all-modals/error-message/error-message.component';
import { SuccessMessageComponent } from '../../all-modals/success-message/success-message.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss']
})
export class EditProfileComponent implements OnInit, OnDestroy {

  @Input() currentuser: any;
  token: any;
  max = new Date(new Date().setFullYear(new Date().getFullYear() - 18));
  min: any;
  editProfileForm: FormGroup;
  submitted: boolean = false;
  textAreaLength = 0;
  textAreaLengthAddress = 0;
  imagePath: any;
  imgURL: any = environment.url;
  file: File;
  isImageError: boolean = false;
  isImageSizeError: boolean = false;
  isSvgImageError: boolean = false;
  cityList: any = [];

  selectedCity: any = null;
  dropdownSettings: any;
  userType: any;
  userCategories: any;
  industryType: any;
  dateErrorMsg: string = "Please enter a valid DOB";
  imageErrorMsg: string = LITERALS.VALIDATION.IMAGE_VALIDATION;
  cityListSubscriber: Subscription;
  @ViewChild('angularMultiselect', { static: false }) angularMultiselect: any;

  constructor(
    private activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    public authService: AuthService,
    private spinner: NgxSpinnerService,
    public datePipe: DatePipe,
    private _profileService: ProfileService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    // this.currentuser = this.authService.getCurrentUser();
    this.token = this.currentuser.token;
    // this.getCurrentUser();
    this.userType = this.currentuser.user.user_type;
    this.initializeForm();
    // this.spinner.hide();
  }

  initializeForm() {
    if (this.currentuser.user.user_account_type == "supplementary") {
      this.min = new Date(new Date().setFullYear(new Date().getFullYear() - 18));
      this.min.setDate(this.min.getDate() + 1);
      this.min.setHours(0, 0, 0, 0);

      this.max = new Date();
      // this.dateErrorMsg = "User must be 18 years below"
    }

    if (!this.currentuser) {
      return;
    }

    this.dropdownSettings = {
      singleSelection: true,
      text: "Select Country",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      noDataLabel: "No country found",
      classes: "form-control",
      labelKey: 'name'
    };

    if (this.userType == 'business') {
      this.getCitiesList(this.currentuser.user.locations.country, true);
      this.editProfileForm = this.formBuilder.group({
        name: [this.currentuser.user.business_profile[0].name, Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.BUISNESS_NAME_PATTERN), this.noWhitespaceValidator, Validators.maxLength(45)])],
        industry_id: [this.currentuser.user.business_profile[0].industry_id, [Validators.required]],
        about: [this.currentuser.user.business_profile[0].about, Validators.pattern(REGEX_PATTERNS.TEXT_AREA)],
        business_address: [this.currentuser.user.business_profile[0].business_address, Validators.pattern(REGEX_PATTERNS.TEXT_AREA)],
        status: [this.currentuser.user.status, [Validators.required]],
        city: [''],
        // user_category_id: [this.currentuser.user.user_category_id, [Validators.required]],
        // verification_proof_no: [this.currentuser.user.business_profile[0].verification_proof_no]
      });
    }
    else {
      this.getCitiesList(this.currentuser.user.locations.country, true);

      this.editProfileForm = this.formBuilder.group({
        name: [this.currentuser.user.name, Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.BUISNESS_NAME_PATTERN), this.noWhitespaceValidator, Validators.maxLength(45)])],
        user_category_id: [this.currentuser.user.user_category_id, [Validators.required]],
        about: [this.currentuser.user.about, Validators.pattern(REGEX_PATTERNS.TEXT_AREA)],
        birth_date: [new Date(this.currentuser.user.birth_date), Validators.compose([Validators.required])],
        city: [''],
        status: [this.currentuser.user.status, [Validators.required]]
        // phone: [this.currentuser.user.phone, [Validators.required]]
      });
    }

    this.loadUserCategories();
    this.loadIndustryType();

    if (this.currentuser.user.avatar)
      this.imgURL += this.currentuser.user.avatar;
    else
      this.imgURL = null;

    this.textAreaLength = (this.currentuser.user.about) ? this.currentuser.user.about.length : 0;
    if (this.currentuser.user.business_profile && this.currentuser.user.business_profile[0].business_address) {
      this.textAreaAdjustAddress = this.currentuser.user.business_profile[0].business_address.length;
    }
  }

  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  getCurrentUser() {
    this.authService.getCurrentUserData(this.currentuser.user.id).subscribe(
      (response) => {
        if (response.success) {
          this.currentuser.user = response.data.user;
          this.redirectUser(response.data.user);
        }
      })
  }

  loadUserCategories() {
    this._profileService.loadUserCategory().subscribe(
      (response: any) => {
        if (response.success) {
          this.userCategories = response.data.user_category;
        }
        else {
          // this.toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
        }
      }, (error: any) => {

      });
  }

  loadIndustryType() {
    this._profileService.loadIndustryType().subscribe(
      (response: any) => {
        if (response.success) {
          this.industryType = response.data.industry;
        }
        else {
          // this.toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
        }
      });
  }

  preview(files) {
    this.isImageError = false;
    this.isImageSizeError = false;
    this.isSvgImageError = false;
    if (files.length === 0)
      return;

    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.isImageError = true;
      // this.toastr.warning('Only images are supported.');
      return;
    }
    if (mimeType !== 'image/png' && mimeType !== 'image/jpeg' && mimeType !== 'image/gif') {
      this.isSvgImageError = true;
      return;
    }

    if (files[0].size >= 5242880) {
      this.isImageSizeError = true;
      return;
    }

    var reader = new FileReader();
    this.imagePath = files;
    this.file = files[0];
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imgURL = reader.result;
    }
  }

  filesDropped(files) {
    if (files[0].file.length === 0)
      return;

    var mimeType = files[0].file.type;

    if (mimeType.match(/image\/*/) == null) {
      const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
      modalRef.componentInstance.message = "Only images are supported.";
      this.isImageError = true;
      return;
    }

    if (mimeType !== 'image/png' && mimeType !== 'image/jpeg' && mimeType !== 'image/gif') {
      this.isSvgImageError = true;
      return;
    }

    if (files[0].size >= 5242880) {
      this.isImageSizeError = true;
      return;
    }

    var reader = new FileReader();
    this.file = files[0].file;
    reader.readAsDataURL(files[0].file);
    reader.onload = (_event) => {
      this.imgURL = reader.result;
    }
    this.isImageError = false;
  }

  getCitiesList(event, isCitySelected) {
    if (event && event.length > 2) {
      if (this.cityListSubscriber) {
        this.cityListSubscriber.unsubscribe();
      }
      this.cityList = [];
      this.cityListSubscriber = this._profileService.getCountries(event).subscribe(
        (response: any) => {
          if (response.success) {
            this.cityList = (response.data.countries) ? response.data.countries : [];

            if (isCitySelected) {
              this.selectedCity = this.cityList.find((element) => {
                return element.name === this.currentuser.user.locations.country
              });;
              const selectedCity = [
                this.selectedCity
              ];
              this.editProfileForm.patchValue(
                { city: selectedCity },
                { onlySelf: true }
              );
            }
          }
        }, (error: any) => {
          // this.toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
        });
    }
  }

  clearData(e) {
    if (this.angularMultiselect && !this.angularMultiselect.filter) {
      this.cityList = [];
    }
  }

  onItemSelect(item: any) {
    this.selectedCity = item;
  }
  onItemDeSelect(item) {
    this.selectedCity = null;
  }

  onSubmit() {
    if (this.currentuser.user.user_turned_eighteen && this.currentuser.user.user_account_type != 'owner') {
      const birth_date = this.editProfileForm.controls.birth_date;
      birth_date.clearValidators();
      birth_date.updateValueAndValidity();
    }
    this.submitted = true;
    if (this.editProfileForm.invalid) {
      return;
    }
    let params;
    if (this.userType == 'business') {
      params = {
        user: {
          // user_category_id: this.editProfileForm.value.user_category_id,
          status: this.editProfileForm.value.status,
        },
        user_business: {
          about: this.editProfileForm.value.about ? this.editProfileForm.value.about : '',
          name: this.editProfileForm.value.name.trim(),
          industry_id: this.editProfileForm.value.industry_id,
          business_address: this.editProfileForm.value.business_address.trim(),
          // verification_proof_no: this.editProfileForm.value.verification_proof_no
        }
      };
    }
    else {
      params = {
        user: {
          name: this.editProfileForm.value.name.trim(),
          about: this.editProfileForm.value.about ? this.editProfileForm.value.about.trim() : '',
          // phone: this.editProfileForm.value.phone,
          user_category_id: this.editProfileForm.value.user_category_id,
          birth_date: this.editProfileForm.value.birth_date,
          user_type: this.editProfileForm.value.type,
          status: this.editProfileForm.value.status,
        }
      };

      params.user.birth_date = this.datePipe.transform(params.user.birth_date, 'dd/MM/yyyy');
    }
    if (this.selectedCity && this.selectedCity.name !== undefined && this.selectedCity.name) {
      params.user.locations_attributes = [
        {
          // id: this.selectedCity.id,
          // city: this.selectedCity.name,
          country: this.selectedCity.name,
          id: this.currentuser.user.locations.id
          // latitude: this.selectedCity.latitude,
          // longitude: this.selectedCity.longitude,
          // state: this.selectedCity.state_name
        }];
    } else {
      params.user.locations_attributes = [
        {
          //id: 0,
          // city: this.selectedCity.name,
          country: "",
          // latitude: this.selectedCity.latitude,
          // longitude: this.selectedCity.longitude,
          // state: this.selectedCity.state_name
        }];
    }
    if (this.file) {
      params.user['avatar'] = this.file;
    }

    params.user.user_type = this.userType;

    this.spinner.show();
    this.authService.editUserProfile(this.currentuser.user.id, params, this.userType).subscribe(
      (response: any) => {
        this.spinner.hide();
        if (response.success) {
          this.redirectUser(response.data.user);
          const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
          modelRef.componentInstance.message = LITERALS.AUTH.SUCCESS_MESSAGES.USER_UPDATED;
          this.closeDialog(true);
        }
        else if (response.status == 422) {
          const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modalRef.componentInstance.message = response.errors;
        } else {
          const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modalRef.componentInstance.message = "Error occured during updating user";
        }
      }, (error: any) => {
        this.spinner.hide();
      });
  }
  closeDialog(status) {
    this.activeModal.close(status);
  }
  redirectUser(userObj) {
    const currentUser = {
      token: this.token,
      user: userObj
    }

    let rememberMe = localStorage.getItem('rememberMe');
    if (rememberMe == 'true')
      localStorage.setItem('currentUser', JSON.stringify(currentUser));
    else
      sessionStorage.setItem('currentUser', JSON.stringify(currentUser));
  }
  textAreaAdjust(event) {
    this.textAreaLength = event.target.value.length;
    // event.target.style.height = "1px";
    // event.target.style.height = (event.target.scrollHeight) + "px";
  }
  textAreaAdjustAddress(event) {
    this.textAreaLengthAddress = event.target.value.length;
    // event.target.style.height = "1px";
    // event.target.style.height = (event.target.scrollHeight) + "px";
  }

  restrictNumeric(event) {
    //firefox solution
    event = event || window.event;
    var charCode = (typeof event.which == "undefined") ? event.keyCode : event.which;
    var charStr = String.fromCharCode(charCode);

    if (!charStr.match(/^[0-9/]+$/))
      event.preventDefault();
    const restrictKeycodes = [101, 46, 43, 45];
    if (restrictKeycodes.includes(event.keyCode) || event.target.value.length > 11) {
      return false;
    }
  }

  restrictNumericPaste(event) {
    let text = event.clipboardData.getData('text').toString();
    let filteredText = text.replace(REGEX_PATTERNS.NUMBER_REMOVE_DATE, "");
    // this.editProfileForm.controls.birth_date.setValue(filteredText);
    if (!event.target.readOnly && !event.target.disabled)
      event.target.value = filteredText;

    event.preventDefault();
  }

  ngOnDestroy() {
    if (this.cityListSubscriber) {
      this.cityListSubscriber.unsubscribe();
    }
  }
}
